// @flow
import * as React from 'react';
import PhoneInput from 'bizom-mui/lib/PhoneInput';
import { Field, getIn } from 'formik';
import { PLEASE_ENTER_VALID_MOBILE_NUMBER } from 'constants/errors';
type Props = {
  component?: React.ElementType,
  disabled?: boolean,
  defaultCountry?: string,
  dialCodeFieldName: string,
};

const FormikPhoneField = ({
  component,
  disabled,
  defaultCountry,
  dialCodeFieldName,
  ...fieldProps
}: Props) => (
  <React.Fragment>
    <Field {...fieldProps}>
      {({ field, form, ...props }) => {
        const ComponentProp = component || PhoneInput;
        const { name, value } = field;
        const { errors, isSubmitting, setFieldValue, setFieldError } = form;
        const fieldError = getIn(errors, name);
        const showError = !!fieldError;
        return (
          <ComponentProp
            {...fieldProps}
            {...props}
            {...field}
            country={defaultCountry}
            enableSearch={true}
            countryCodeEditable={false}
            onChange={(value, data, event) => {
              setFieldValue(name, value);
              setFieldValue(dialCodeFieldName, data.dialCode);
            }}
            isValid={(inputNumber, country, countries) => {
              const isValid = countries.some(
                ({ dialCode }) =>
                  inputNumber.startsWith(dialCode) ||
                  dialCode.startsWith(inputNumber)
              );

              if (!errors[name] && !isValid) {
                setFieldError(name, PLEASE_ENTER_VALID_MOBILE_NUMBER);
              }
              return isValid;
            }}
            value={value === undefined ? '' : value}
            error={showError}
            helperText={showError ? fieldError : props.helperText}
            disabled={isSubmitting || disabled}
          />
        );
      }}
    </Field>
    <Field type="hidden" name={dialCodeFieldName} />
  </React.Fragment>
);

export default FormikPhoneField;
